

















import Vue from 'vue'

import TableTags from './table-tag.vue'
import TagProperties from './tag-properties.vue'

import { Find as FindDevice } from '@/api/device'
import { Device } from '../../../types/device'

const excel = require('../../../utils/Export2Excel')

const { Splitpanes, Pane } = require('splitpanes')
import 'splitpanes/dist/splitpanes.css'
import { Tag } from '@/types/tag'

interface SelectOptions {
  value: string | number
  text: string
}

export default Vue.extend({
  name: 'TagEditor',
  components: {
    Splitpanes,
    Pane,
    TableTags,
    TagProperties,
  },
  data() {
    return {
      fields: ['name', 'device_uid', 'value', 'type'],
      selected: {} as Tag,
      devices: [] as Device[],
    }
  },
  computed: {
    optsDevice(): SelectOptions[] {
      const options: SelectOptions[] = [{ value: 0, text: 'Virtual' }]

      for (const i in this.devices) {
        options.push({
          value: this.devices[i].id,
          text: this.devices[i].name,
        })
      }

      return options
    },
  },
  methods: {
    async findDevices() {
      this.devices = await FindDevice()
    },

    selectedChanged(val: Tag) {
      this.selected = val
    },
  },

  created() {
    this.findDevices()
  },
})
